// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { LogLevel } from "../app/utils/log-level.enum";

// ################################################### PRODUCCIÓN
export const environment = {
	production: true,
	url: "http://configurador.rivisa.com",
	env: "prod",
	// ESPRRIVISA-131
	logger: {
		level: LogLevel.WARN,
		serverLevel: LogLevel.OFF,
		// serverUrl: 'http://',
		disableConsoleLogging: false,
	},
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
